module.exports = __webpack_public_path__ + "image-81165aa97a3b.png";